import { breadcrumbSchema, clinicListSchema } from "../structured-data-core";
import { clinicsIn } from "../clinics";

// A hub page lists the clinics and links to each clinic's own page. The
// clinic nodes live on those pages, not here.
export function getDenverStructuredData() {
  return [
    clinicListSchema("RESTORE Hair clinics in Denver and Colorado", "/locations/restore-denver/", clinicsIn("denver")),
    breadcrumbSchema([
      { name: "Locations", path: "/locations/" },
      { name: "Denver", path: "/locations/restore-denver/" },
    ]),
  ];
}
